<template>
  <div>
    <v-card flat class="pa-2">
      <v-row>
          <v-alert
            type="warning"
            dismissible
            transition="fade-transition"
            dense
            class="mb-4"
            bordered
            border="left"
            color="warning"
            colored-border
            elevation="5"
          >
            {{ $t('voice_gallery.autoplay_warning') }}
          </v-alert>       
           <!-- chose type of card -->
        <v-col cols="12">

          <v-card-subtitle class="pa-0">{{ $t('select_music_card') }}</v-card-subtitle>
          <v-radio-group v-model="audios.audioType" hide-details row>
            <v-radio
              v-for="(item, i) in typeCardGallery"
              :value="item.name"
              :key="i"
            >
              <template v-slot:label>
                <v-img
                  contain
                  class="rounded-xl"
                  :src="item.src"
                  width="50"
                  height="50"
                />
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>

        <!-- switch to show -->
        <v-col>
          <v-switch
            v-if="audios.audios.length"
            v-model="showAudios"
            :label="showAudios ? $t('hide_audio') : $t('show_audio')"
          ></v-switch>
        </v-col>

        <!-- card of music -->
        <v-col cols="12" v-for="(audio, i) in audios.audios" :key="i">
          <v-card
            class="py-2 align-items-center border d-flex justify-content-between"
            flat
          >
            <v-card-subtitle
              v-if="!showAudios"
              style="width: 90%"
              class="pa-0 d-flex justify-content-between align-items-center"
              dense
            >
              <v-icon
                @click="
                  disc = true;
                  copyAudios = i;
                "
                size="15"
                color="primary"
                class="mb-1 ml-3"
                >mdi-pencil</v-icon
              >
              {{ audio.title.length > 0 ? audio.title : $t('audio_file') }}

              <v-icon
                @click="deleteFromGallery(audio.id)"
                style="cursor: pointer"
                >mdi-delete</v-icon
              >
            </v-card-subtitle>
            <v-card-text
              class="pa-0 d-flex align-items-center"
              v-if="showAudios"
            >
              <v-row>
                <v-col cols="1"
                  ><v-icon
                    @click="
                      disc = true;
                      copyAudios = i;
                    "
                    size="15"
                    color="primary"
                    class="mb-1 ml-3"
                    >mdi-pencil</v-icon
                  ></v-col
                >
                <v-col cols="10">
                  <component
                    :is="audios.audioType"
                    :audioSound="false"
                    :flat="true"
                    :file="audio.full_path"
                    :title="audio.title.length > 0 ? audio.title : $t('audio_file')"
                    :link="false"
                    editCover
                    width="100%"
                    :id="audio.id"
                    :height="audios.audioType == 'newPlayer' ? 280 : 150"
                    :image="audio?.image"
                    @click="updateTitle"
                    @image="imageHandler"
                    :color="audio?.color"
                    :background="audio?.background"
                  />
                </v-col>
                <v-col cols="1"
                  ><v-card-actions
                    style="width: 10%"
                    class="d-flex justify-content-center"
                  >
                    <v-icon
                      @click="deleteFromGallery(audio.id)"
                      style="cursor: pointer"
                      >mdi-delete</v-icon
                    >
                  </v-card-actions></v-col
                >
              </v-row>

              <!-- 280 -->
            </v-card-text>
          </v-card>
        </v-col>

        <!-- add button -->
        <v-col cols="12" class="w-100">
          <v-btn
            :disabled="audios.audios.length >= maxLength"
            color="green"
            @click="dialog = true"
            class="w-100"
            outlined
          >
            <v-icon>mdi-plus</v-icon>
            {{ $t('add_voice') }}
          </v-btn>
          <v-card-subtitle v-if="audios.audios.length === maxLength">
            {{ $t('max_files_limit') }} {{ persian(maxLength) }} {{ $t('files_not_allowed') }}
          </v-card-subtitle>
        </v-col>
      </v-row>
    </v-card>

    <!-- gallery -->
    <custom-popup
      @action="addFileFromGallery"
      v-model="dialog"
      :cons="{ title: $t('voice_gallery') }"
    >
      <audio-gallery
        v-model="files"
        :audioSelects="audios.audios"
        :dialog="dialog"
      />
    </custom-popup>
    <!-- list -->
    <custom-popup
      v-model="disc"
      max-height="800px"
      max-width="400px"
      :cons="{ title: $t('edit_voice') }"
      hideConfirm
    >
      <custom-tabs
        v-model="tabs"
        :tab-items="[
          { text: $t('list'), icon: 'text-box-outline' },
          { text: $t('color'), icon: 'invert-colors' },
        ]"
        grow
        :key="copyAudios"
      >
        <template v-slot:staticItems>
          <v-tab-item>
            <v-card flat class="pa-2">
              <v-text-field
                v-model="audios.audios[copyAudios].title"
                :label="$t('file_name')"
                outlined
                dense
              />
              <v-text-field
                v-model="audios.audios[copyAudios].ti"
                :label="$t('title')"
                outlined
                dense
              />
              <v-text-field
                v-model="audios.audios[copyAudios].link"
                :label="$t('link')"
                outlined
                dense
              />
              <v-textarea
                v-model="audios.audios[copyAudios].desc"
                :label="$t('description')"
                outlined
                dense
              />
            <v-switch
              v-model="audios.audios[copyAudios].autoPlay"
              :label="$t('voice_gallery.autoplay')"
              @change="handleAutoPlay(copyAudios)"
              dense
            />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="pa-2">
              <v-card-subtitle>{{ $t('background') }}</v-card-subtitle>
              <color-pallete v-model="audios.audios[copyAudios].background" />
              <v-card-subtitle>{{ $t('text_color') }}</v-card-subtitle>
              <v-card-text class="pa-0">
                <color-picker
                  :lable="$t('text')"
                  v-model="audios.audios[copyAudios].color"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </template>
      </custom-tabs>
    </custom-popup>

    <!-- pic selector -->
    <pic-selector-pop-up
      :field.sync="image"
      :edit-img="false"
      :edit-name="false"
      single
      one-pic
      :popup.sync="picDialog"
      @change="getImage"
    />

    <!-- <pic-selector/> -->
  </div>
</template>

<script>
import { Bus } from "../../../../main";
import AudioGallery from "./components/audioGallery.vue";
import AudioPlayer from "./components/audioPlayer.vue";
import newPlayer from "./components/audio/newPlayer.vue";
import newPlayer2 from "./components/audio/newPlayer2.vue";
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";
import colorPallete from "../../colorPallete.vue";
import PicSelector from "../picSelector.vue";
import PicSelectorPopUp from "./template/picSelectorPopUp.vue";

export default {
  name: "voiceGallery",
  components: {
    AudioGallery,
    AudioPlayer,
    newPlayer,
    newPlayer2,
    ColorPicker,
    colorPallete,
    PicSelector,
    PicSelectorPopUp,
  },
  props: {
    value: [Array, Object],
  },
  data() {
    return {
      // dialogs
      dialog: false,
      disc: false,
      picDialog: false,

      // get file from components
      files: [],
      // set file for show
      // audios: [],

      copyAudios: null,

      // switch for show music for play in page
      showAudios: false,

      // linklist
      linklist: [],

      // tabs
      tabs: null,

      // image
      image: "",
      idAudioImage: "",

      audioType: "newCard1",

      typeCardGallery: [
        {
          name: "newPlayer",
          src: "/media/music/card.webp",
        },
        {
          name: "newPlayer2",
          src: "/media/music/card2.webp",
        },
      ],
    };
  },

  watch: {
    disc(val) {
      if (val) {
        this.tabs = null;
        let item = this.audios.audios[this.copyAudios];
        this.$set(this.audios.audios, this.copyAudios, {
          ...item,
          ti: item.ti ?? "",
          link: item.link ?? "",
          desc: item.desc ?? "",
          id: item.id ?? "",
          color: item.color ?? "#878585FF",
          background: item.background ?? "#FFFFFF00",
          title: item.title ?? "",
        });
        this.$forceUpdate();
        console.log(this.audios.audios[this.copyAudios]);
      }
    },
    picDialog(val) {
      if (!val) {
        this.idAudioImage = null;
      }
    },
  },

  inject: {
    maxChoseLength: { default: 9999 },
  },

  computed: {
    audios: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    maxLength() {
      return this.maxChoseLength;
    },
  },

  mounted() {
    this.audios.audios?.length > 12
      ? (this.showAudios = false)
      : (this.showAudios = true);
    Bus.$on("linklist", (val) => {
      if (val) {
        this.audios.audios.push(...val);
        this.dialog = false;
      }
    });
    Bus.$on("gradientType", (e) => {});
  },

  methods: {
  async handleAutoPlay(selectedIndex) {
    if (this.audios.audios[selectedIndex].autoPlay) {
      const confirm = await this.$modal.yesNo(
        "در صورت انتخاب پخش خودکار صوتی سرعت لود کیوآر شما کاهش خواهد یافت. آیا مایل به فعال کردن پخش خودکار هستید؟"
      );

      if (confirm) {
        this.audios.audios.forEach((audio, index) => {
          if (index !== selectedIndex) {
            this.$set(audio, 'autoPlay', false);
          }
        });
      } else {
        this.$set(this.audios.audios[selectedIndex], 'autoPlay', false);
      }
    }
  },
    addFileFromGallery(e) {
      if (e === "submit") {
        const mergedArray = [...this.audios.audios, ...this.files];
        const uniqueArray = mergedArray.reduce((acc, current) => {
          const existingItem = acc.find((item) => item.id === current.id);
          if (!existingItem) {
            acc.push(current);
          } else {
            Object.assign(existingItem, current);
          }
          return acc;
        }, []);

        this.audios.audios = uniqueArray;
      }
    },

    async deleteFromGallery(id) {
      if (
        await this.$modal.yesNo(
          this.$t("delete_audio_confirm")
        )
      ) {
        const filtered = this.audios.audios.filter((item) => item.id !== id);
        this.$set(this.audios, "audios", filtered);
        this.files = this.files.filter((item) => item.id !== id);
        this.$toast.success(this.$t("deleted_successfully"));
      }
    },
    updateTitle({ id, title }) {
      let edit = this.audios.audios.map((audio) => {
        if (audio.id == id) {
          return { ...audio, title };
        } else {
          return audio;
        }
      });
      this.audios.audios = edit;
    },

    // set image
    imageHandler(e) {
      this.idAudioImage = e;

      this.picDialog = true;
    },

    getImage(e) {
      this.audios.audios = this.audios.audios.map((item) => {
        if (item.id == this.idAudioImage) {
          return { ...item, image: e };
        } else return item;
      });
    },
  },
};
</script>

<style scoped>
.v-input >>> .v-label {
  margin: 0;
}

.v-input >>> .v-input--selection-controls__input {
  align-self: flex-start;
}
</style>
